/* eslint-disable max-len */
import React from 'react';
//////////////////////////////////////////////////

const dashboards = (color, width, height) => (
  <svg
    viewBox='0 0 16 16'
    width={width || 16}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M6 2a.5.5 0 0 1 .47.33L10 12.036l1.53-4.208A.5.5 0 0 1 12 7.5h3.5a.5.5 0 0 1 0 1h-3.15l-1.88 5.17a.5.5 0 0 1-.94 0L6 3.964 4.47 8.171A.5.5 0 0 1 4 8.5H.5a.5.5 0 0 1 0-1h3.15l1.88-5.17A.5.5 0 0 1 6 2Z'
    />
  </svg>
);

const dispatchTemplate = (color, width, height) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M0 .125v14.75h15V.125H0zm14.5 14.25H.5V.625h14v13.75zm-6.75-2.25h4.5a.25.25 0 1 0 0-.5h-4.5a.25.25 0 1 0 0 .5zm0-1.75h2.75a.25.25 0 1 0 0-.5H7.75a.25.25 0 1 0 0 .5zm0-1.75h4.5a.25.25 0 1 0 0-.5h-4.5a.25.25 0 1 0 0 .5zm0-1.75h4a.25.25 0 1 0 0-.5h-4a.25.25 0 1 0 0 .5zm0-1.75h3a.25.25 0 1 0 0-.5h-3a.25.25 0 1 0 0 .5zm0-1.75h4.5a.25.25 0 1 0 0-.5h-4.5a.25.25 0 1 0 0 .5zm-5.323 7.323a.25.25 0 1 0-.354.354l1.75 1.75a.248.248 0 0 0 .177.073.248.248 0 0 0 .177-.073l1.75-1.75a.25.25 0 1 0-.354-.354L4.25 12.021V2.979l1.323 1.324a.25.25 0 1 0 .354-.354l-1.75-1.75a.25.25 0 0 0-.354 0l-1.75 1.75a.25.25 0 1 0 .354.354L3.75 2.979v9.042l-1.323-1.323z'
    />
  </svg>
);

const dispatchTemplate2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M1.313 1.042a.64.64 0 0 0-.262.249c-.03.06-.038.284-.038 1.211l.055 1.244c.066.129.17.205.331.246.085.022.815.027 2.431.022l2.395-.055c.118-.063.221-.194.257-.317a22.11 22.11 0 0 0-.003-2.259c-.041-.15-.126-.254-.257-.317-.109-.055-.167-.055-2.477-.052l-2.431.027zm6.458.027a.45.45 0 0 0-.249.312c-.025.082-.03 1.034-.025 3.697l.008 3.585.082.118c.167.232-.036.216 2.663.216h2.39l.112-.066c.063-.036.139-.115.175-.175l.06-.109v-3.64l-.038-3.716a.63.63 0 0 0-.271-.249c-.052-.022-.837-.03-2.434-.03l-2.475.057zM1.296 5.056a.58.58 0 0 0-.191.156l-.079.101-.008 3.667.044 3.763a.72.72 0 0 0 .167.178l.118.082 2.335.008 2.453-.025c.142-.038.304-.197.345-.339.041-.148.041-7.118.003-7.265a.53.53 0 0 0-.287-.325c-.104-.049-.238-.052-2.447-.052l-2.45.052zm6.511 4.99a.61.61 0 0 0-.284.336c-.041.145-.041 2.119 0 2.264s.202.301.345.339c.082.022.793.03 2.453.025l2.335-.008.118-.082c.222-.159.216-.126.216-1.4l-.03-1.203c-.041-.109-.131-.2-.257-.257-.104-.049-.232-.052-2.461-.049l-2.434.036z'
    />
  </svg>
);

const dispatcher = (color, width, height) => (
  <svg
    viewBox='0 0 22 24'
    width={width || 22}
    height={height || 24}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#4c4c4c'}
      d='M19.365 17.415l-.027-.032a9.01 9.01 0 0 0-3.452-2.543 7.55 7.55 0 0 1-10.359.062 9 9 0 0 0-3.31 2.48l-.027.033C.738 19.157.002 21.135.002 23.295V24h21.551v-.706c0-2.16-.736-4.137-2.188-5.88zM3.256 11.294h1.529a6.41 6.41 0 0 1-.317-1.412h5.305v1.412H4.786c.103.297.229.584.373.858a6.36 6.36 0 0 0 1.915 2.203c1.018.73 2.26 1.161 3.6 1.161 1.354 0 2.609-.439 3.633-1.184.646-.472 1.205-1.067 1.633-1.747a6.42 6.42 0 0 0 .622-1.29h1.587c.889 0 1.612-.734 1.612-1.634v-.485c0-5.06-4.063-9.176-9.058-9.176s-9.06 4.117-9.06 9.176v.485c0 .9.724 1.633 1.613 1.633zm7.447-9.882c3.502 0 6.462 2.391 7.374 5.647H16.55c-.866-2.44-3.173-4.19-5.876-4.19s-5.01 1.75-5.877 4.19h-1.47C4.24 3.803 7.2 1.412 10.704 1.412z'
    />
  </svg>
);

const dispatchingGroup = (color, width, height) => (
  <svg
    viewBox='0 0 18 15'
    width={width || 18}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#930000'}>
      <path d='M5.73 4.023c0 .877.347 1.89.926 2.708.657.93 1.489 1.44 2.341 1.44s1.684-.51 2.341-1.44c.58-.819.925-1.831.925-2.708 0-1.786-1.465-3.24-3.266-3.24s-3.266 1.454-3.266 3.24zm3.267-2.677c1.488 0 2.699 1.201 2.699 2.677 0 .754-.315 1.668-.822 2.385-.54.763-1.225 1.201-1.877 1.201S7.661 7.171 7.12 6.408c-.507-.717-.822-1.63-.822-2.385 0-1.476 1.21-2.677 2.7-2.677zm2.437 6.198a.285.285 0 0 0-.322.055c-.634.627-1.366.958-2.115.958s-1.48-.331-2.115-.958a.285.285 0 0 0-.322-.055 5.673 5.673 0 0 0-2.337 2.04 5.574 5.574 0 0 0-.902 3.044v.005a.28.28 0 0 0 .093.208 8.333 8.333 0 0 0 5.583 2.135 8.333 8.333 0 0 0 5.583-2.135.28.28 0 0 0 .093-.208v-.005a5.575 5.575 0 0 0-.902-3.045 5.671 5.671 0 0 0-2.337-2.04zm-2.437 6.87a7.765 7.765 0 0 1-5.107-1.906c.022-.934.3-1.837.81-2.62a5.106 5.106 0 0 1 1.93-1.75c.709.643 1.524.982 2.367.982s1.658-.339 2.367-.982a5.106 5.106 0 0 1 1.93 1.75c.51.783.788 1.686.81 2.62a7.765 7.765 0 0 1-5.107 1.906z' />
      <path d='M17.209 7.72a4.943 4.943 0 0 0-2.037-1.777.285.285 0 0 0-.322.055c-.541.535-1.165.818-1.802.818-.346 0-.688-.082-1.017-.245a.285.285 0 0 0-.38.125.28.28 0 0 0 .127.378c.408.202.835.305 1.27.305.73 0 1.437-.29 2.053-.842a4.38 4.38 0 0 1 1.631 1.489 4.3 4.3 0 0 1 .693 2.228 6.71 6.71 0 0 1-2.416 1.336.28.28 0 1 0 .166.538 7.28 7.28 0 0 0 2.726-1.541.28.28 0 0 0 .093-.209v-.003a4.86 4.86 0 0 0-.785-2.654zM4.935 6.468a2 2 0 0 0 .889-.216.28.28 0 0 0 .128-.377.285.285 0 0 0-.38-.127 1.436 1.436 0 0 1-.637.157c-.55 0-1.129-.372-1.587-1.02-.433-.612-.702-1.391-.702-2.035A2.282 2.282 0 0 1 4.935.58c.595 0 1.16.226 1.588.636a.285.285 0 0 0 .401-.007.28.28 0 0 0-.007-.397A2.854 2.854 0 0 0 4.935.018c-1.575 0-2.856 1.27-2.856 2.832 0 .765.3 1.646.804 2.358.575.812 1.303 1.26 2.052 1.26z' />
      <path d='M2.308 11.33a6.638 6.638 0 0 1-1.74-1.087c.023-.792.26-1.558.693-2.222a4.365 4.365 0 0 1 1.626-1.484c.614.55 1.318.84 2.047.84a2.85 2.85 0 0 0 1.28-.31.28.28 0 0 0 .125-.379.285.285 0 0 0-.381-.124c-.331.166-.675.25-1.024.25-.635 0-1.257-.282-1.796-.816a.285.285 0 0 0-.322-.055A4.932 4.932 0 0 0 .784 7.716 4.846 4.846 0 0 0 0 10.364v.003c0 .08.034.155.093.209.591.531 1.26.959 1.99 1.27a.285.285 0 0 0 .373-.146.28.28 0 0 0-.148-.37zm.334.408c-.101.241.17.48.401.352a.282.282 0 0 0 .122-.352c-.091-.23-.43-.224-.523 0zm8.829-10.522c.429-.41.993-.635 1.588-.635a2.282 2.282 0 0 1 2.29 2.27c0 .643-.27 1.422-.703 2.034-.458.648-1.037 1.02-1.587 1.02a1.42 1.42 0 0 1-.636-.157.285.285 0 0 0-.38.127.28.28 0 0 0 .127.377c.29.143.59.216.89.216.748 0 1.476-.447 2.05-1.26.505-.712.805-1.593.805-2.358 0-1.561-1.28-2.832-2.856-2.832-.743 0-1.447.282-1.982.794a.28.28 0 0 0-.007.397.285.285 0 0 0 .401.007z' />
    </g>
  </svg>
);

const dnd = (color, width, height) => (
  <svg
    viewBox='0 0 50 50'
    width={width || 50}
    height={height || 50}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill={color || '#2073a1'}>
      <path d='M44.746 18.478H34.24a1.051 1.051 0 0 0 0 2.102h10.507a3.156 3.156 0 0 1 3.153 3.152v21.014a3.156 3.156 0 0 1-3.153 3.153H23.732a3.156 3.156 0 0 1-3.152-3.153v-8.405a1.051 1.051 0 0 0-2.102 0v8.405A5.26 5.26 0 0 0 23.732 50h21.014A5.26 5.26 0 0 0 50 44.746V23.732a5.26 5.26 0 0 0-5.254-5.254zm-29.529 10.87H14.13a1.087 1.087 0 0 0 0 2.174h1.087a1.087 1.087 0 0 0 0-2.174zM6.18 0h-.926a5.27 5.27 0 0 0-1.476.21 1.054 1.054 0 0 0-.714 1.305 1.052 1.052 0 0 0 1.305.713c.286-.085.582-.127.885-.127h.926A1.05 1.05 0 1 0 6.18 0zM2.101 25.337v-2.124a1.051 1.051 0 0 0-2.101 0v2.124a1.051 1.051 0 0 0 2.101 0zM1.05 20.014a1.05 1.05 0 0 0 1.052-1.05v-2.125a1.051 1.051 0 0 0-2.102 0v2.124a1.05 1.05 0 0 0 1.05 1.051zm0-12.745a1.05 1.05 0 0 0 1.052-1.05v-.965a3.21 3.21 0 0 1 .117-.858A1.05 1.05 0 0 0 1.494 3.1a1.043 1.043 0 0 0-1.296.725A5.3 5.3 0 0 0 0 5.254v.964a1.05 1.05 0 0 0 1.05 1.05zm0 6.374c.58 0 1.052-.471 1.052-1.051v-2.125a1.051 1.051 0 0 0-2.102 0v2.125a1.05 1.05 0 0 0 1.05 1.05zM4.392 29.3a3.162 3.162 0 0 1-1.357-.796 1.052 1.052 0 0 0-1.482 1.49 5.247 5.247 0 0 0 2.265 1.328 1.05 1.05 0 0 0 .574-2.021zM30.3 5.12a1.05 1.05 0 0 0 1.009-1.347 5.258 5.258 0 0 0-1.347-2.256 1.05 1.05 0 1 0-1.477 1.494 3.18 3.18 0 0 1 .807 1.352c.135.458.553.756 1.009.756zM25.3 0h-2.125a1.051 1.051 0 0 0 0 2.102h2.124A1.051 1.051 0 0 0 25.3 0zM10.463 29.42H8.34a1.051 1.051 0 0 0 0 2.102h2.124a1.051 1.051 0 0 0 0-2.102zM30.471 7.25a1.05 1.05 0 0 0-1.05 1.05v2.125a1.051 1.051 0 0 0 2.1 0V8.301a1.05 1.05 0 0 0-1.05-1.051zM18.928 0h-2.125a1.05 1.05 0 1 0 0 2.102h2.123A1.052 1.052 0 1 0 18.928 0zm-6.374 0h-2.125a1.051 1.051 0 0 0 0 2.102h2.125a1.051 1.051 0 0 0 0-2.102zm17.881 13.043a1.09 1.09 0 0 0-1.087 1.087v1.087a1.087 1.087 0 0 0 2.174 0V14.13a1.09 1.09 0 0 0-1.087-1.087z' />
      <path d='M34.703 18.372l-3.245-3.277a3.249 3.249 0 0 0-4.62 0 3.29 3.29 0 0 0-.801 1.33 3.305 3.305 0 0 0-3.385.784 3.296 3.296 0 0 0-.896 1.708c-.998-.141-2.04.201-2.767.935a3.312 3.312 0 0 0-.948 2.562 3.238 3.238 0 0 0-1.867.937 3.295 3.295 0 0 0-.957 2.334c0 .882.34 1.713.957 2.334l.938.948v3.79c0 2.914 2.348 5.286 5.233 5.286h4.29c6.29 0 11.408-5.169 11.408-11.523 0-3.076-1.186-5.97-3.34-8.148zm-8.067 17.557h-4.291c-1.731 0-3.14-1.423-3.14-3.171V31.08l2.4 2.425a1.04 1.04 0 0 0 1.48 0 1.068 1.068 0 0 0 0-1.497l-5.431-5.486a1.18 1.18 0 0 1-.343-.838c0-.315.121-.613.343-.837a1.192 1.192 0 0 1 1.66 0l2.292 2.315a1.04 1.04 0 0 0 1.48 0 1.068 1.068 0 0 0 0-1.495l-2.617-2.643a1.194 1.194 0 0 1 0-1.676 1.192 1.192 0 0 1 1.66 0l1.57 1.586a1.04 1.04 0 0 0 1.48 0 1.068 1.068 0 0 0 0-1.495l-1.047-1.058a1.194 1.194 0 0 1 0-1.676 1.192 1.192 0 0 1 1.66 0l1.047 1.057a1.04 1.04 0 0 0 1.48 0 1.068 1.068 0 0 0-.002-1.497 1.176 1.176 0 0 1-.344-.837c0-.317.124-.615.346-.837a1.165 1.165 0 0 1 1.66 0l3.244 3.277a9.396 9.396 0 0 1 2.727 6.651c0 5.189-4.178 9.41-9.314 9.41z' />
    </g>
  </svg>
);

const doTemplate = (color, width, height) => (
  <svg
    viewBox='0 0 34 20'
    width={width || 25}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M17.864 18.287c-.008.01-.017.02-.026.029a.35.35 0 0 1-.248.104.35.35 0 0 1-.248-.104.36.36 0 0 1-.015-.487l.537.458zm-.298-15.424l-.405.368H6.722c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h10.493c.19 0 .345.153.351.344zm-3.309 9.479a.35.35 0 0 1-.04.002h-2.623c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h2.554l.109.71zm6.653 7.597H1.85C.83 19.94 0 19.099 0 18.065V2.875C0 1.841.83 1 1.85 1h18.956c-.554.192-1.085.431-1.59.712H1.85c-.633 0-1.148.522-1.148 1.163v1.163h15.704c-.238.285-.461.583-.667.893V4.75H.703v2.326h13.96l-.225.712h-6.24v2.326h5.887l-.006.338.007.374H8.198v2.326h6.25l.228.712H8.198v2.326h7.542v-.217a10.04 10.04 0 0 0 .703.936v2.319h2.838c.517.283 1.062.523 1.63.712zM1.85 9.307c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h1.124c.194 0 .351.159.351.356s-.157.356-.351.356H1.85zm0-3.038c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h7.87c.194 0 .351.159.351.356s-.157.356-.351.356H1.85zm9.369 0c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h1.499c.194 0 .351.159.351.356s-.157.356-.351.356h-1.499zm-8.245 11.44c.194 0 .351.159.351.356s-.157.356-.351.356H1.85c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h1.124zM1.85 12.345c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h1.124c.194 0 .351.159.351.356s-.157.356-.351.356H1.85zm1.124 2.326c.194 0 .351.159.351.356s-.157.356-.351.356H1.85c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h1.124zm7.12 0c.194 0 .351.159.351.356s-.157.356-.351.356h-.75c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h.75zm-.75 3.75c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h.75c.194 0 .351.159.351.356s-.157.356-.351.356h-.75zm.75-6.788c.194 0 .351.159.351.356s-.157.356-.351.356h-.75c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h.75zm-.75-2.326c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h.75c.194 0 .351.159.351.356s-.157.356-.351.356h-.75zm2.249 0c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h1.499c.194 0 .351.159.351.356s-.157.356-.351.356h-1.499zm.75 5.364c.194 0 .351.159.351.356s-.157.356-.351.356h-.75c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h.75zm-.75 3.75c-.194 0-.351-.159-.351-.356s.157-.356.351-.356h1.499c.194 0 .351.159.351.356s-.157.356-.351.356h-1.499zm4.146-1.519H8.198v2.326h7.542v-2.326zm-8.245-6.788V7.788H.703v2.326h6.792zm0 .712H.703v2.326h6.792v-2.326zM.703 13.864v2.326h6.792v-2.326H.703zm0 4.201c0 .641.515 1.163 1.148 1.163h5.645v-2.326H.703v1.163z'
    />
    <circle
      r='9'
      cx='24.359'
      cy='10.486'
      fill='none'
      stroke={color || '#930000'}
    />
    <text fill={color || '#930000'}>
      <tspan x='18.838' y='15.611'> C </tspan>
    </text>
  </svg>
);

const documents = (color, width, height) => (
  <svg
    viewBox='0 0 20 20'
    width={width || 20}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#353535'}
      d='M19.999 8.891a.84.84 0 0 0-.016-.153l-.004-.022a.88.88 0 0 0-.033-.116l-1.798-4.904a.9.9 0 0 0-.846-.585h-.863c-.011 0-.022.003-.032.003l.119-.97c.015-.126-.024-.253-.11-.347a.45.45 0 0 0-.336-.15h-.496l.179-1.136a.44.44 0 0 0-.102-.357C15.577.057 15.452 0 15.321 0H4.988c-.136 0-.264.061-.349.165a.44.44 0 0 0-.09.37l.239 1.113h-.56c-.124 0-.242.051-.328.14a.44.44 0 0 0-.121.33l.063 1.027c-.075-.02-.151-.034-.232-.034h-.913a.9.9 0 0 0-.846.585L.053 8.6c-.014.038-.024.076-.033.116-.002.008-.003.016-.004.024-.009.05-.014.1-.015.15L0 19.115c0 .489.403.885.899.885h18.202c.496 0 .899-.397.899-.885V8.901zm-3.803-4.045a.89.89 0 0 0 .244.037h.232l1.149 3.132h-2.014l.389-3.17zm-1.4-3.959l-.12.762H5.707L5.543.886h9.253zm.778 1.648l-.673 5.481h-9.86l-.336-5.481h10.869zM3.328 4.883h.282c.119 0 .231-.024.335-.065l.196 3.197H2.179l1.148-3.132zm14.875 13.346H1.798V9.787h16.404v8.442zM7.079 14.894h5.842c.497 0 .899-.397.899-.886s-.402-.885-.899-.885H7.079c-.497 0-.899.395-.899.885s.402.886.899.886z'
    />
  </svg>
);

const dollar = (color, width, height) => (
  <svg
    viewBox='0 0 9 16'
    width={width || 9}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#4c4c4c'}
      d='M6.381 7.256c-.627-.347-1.293-.61-1.953-.884-.382-.159-.749-.343-1.072-.6-.637-.509-.515-1.333.231-1.66.211-.092.432-.122.656-.135.865-.046 1.686.112 2.468.488.39.188.518.129.65-.277l.383-1.297c.085-.29-.02-.481-.294-.603a6.28 6.28 0 0 0-1.557-.466c-.706-.108-.706-.112-.71-.821-.003-1-.003-1-1.006-1-.145 0-.29-.003-.435 0-.468.014-.548.096-.56.568l-.004.637c-.003.626-.007.616-.607.834C1.119 2.568.222 3.558.126 5.141.041 6.543.773 7.491 1.924 8.18c.71.425 1.495.676 2.247 1.01.293.128.574.276.818.48.723.598.59 1.59-.267 1.967-.459.201-.944.25-1.442.188-.768-.096-1.504-.297-2.197-.657-.406-.21-.524-.155-.663.284l-.33 1.145c-.142.515-.089.637.403.877.626.304 1.296.459 1.979.568.534.086.55.109.557.663l.007.755c.003.317.155.502.482.508l1.111-.003c.304-.006.459-.171.459-.478l.003-1.033c-.016-.35.136-.528.472-.62a3.73 3.73 0 0 0 1.943-1.247c1.412-1.715.874-4.226-1.125-5.331z'
    />
  </svg>
);

const download = (color, width, height) => (
  <svg
    viewBox='0 0 12 12'
    width={width || 12}
    height={height || 12}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#39729d'}
      d='M0 11.143c0 .473.384.857.857.857h10.286c.473 0 .857-.384.857-.857s-.384-.857-.857-.857H.857c-.473 0-.857.384-.857.857zm3.178-5.039c-.335-.335-.335-.877 0-1.212s.877-.335 1.212 0l.753.753V.857C5.143.384 5.527 0 6 0s.857.384.857.857v4.791l.757-.757c.335-.335.877-.335 1.212 0s.335.877 0 1.212L6.653 8.277l-.047.044c-.155.155-.369.25-.605.25-.248 0-.471-.105-.627-.273l-.022-.021-2.173-2.173z'
    />
  </svg>
);

const downloadButton = (color, width, height) => (
  <svg
    viewBox='0 0 20 20'
    width={width || 20}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#015295'}
      d='M19.444 2.444L17.89.556C17.667.222 17.222 0 16.667 0H3.333c-.555 0-1 .222-1.333.556L.556 2.444C.222 2.89 0 3.334 0 3.89v13.889C0 19 1 20 2.222 20h15.556C19 20 20 19 20 17.778V3.888c0-.555-.222-1-.556-1.444zM10 16.111L3.889 10h3.889V7.778h4.444V10h3.89L10 16.111zM2.333 2.222l.89-1.11h13.333l1 1.11H2.333z'
    />
  </svg>
);

const downloadDocument = (color, width, height) => (
  <svg
    viewBox='0 0 13 16'
    width={width || 13}
    height={height || 16}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      strokeWidth='.3'
      fill={color || '#353535'}
      stroke={color || '#015295'}
      d='M7.93 6.91a.224.224 0 0 0-.227-.222H5.914c-.125 0-.226.1-.226.222v2.278H4.253a.227.227 0 0 0-.21.137.218.218 0 0 0 .05.242l2.556 2.5a.228.228 0 0 0 .32 0l2.556-2.5a.218.218 0 0 0 .05-.242.227.227 0 0 0-.21-.137H7.93V6.91zm.887 2.722L6.81 11.597 4.8 9.632h1.114c.126 0 .227-.1.227-.222V7.132h1.336V9.41c0 .123.101.222.226.222h1.114zm3.719-5.042L8.928 1.067A.243.243 0 0 0 8.76 1H1.719C1.336 1 1 1.305 1 1.68v13.156c0 .19.098.368.235.503a.785.785 0 0 0 .537.208h10.127a.73.73 0 0 0 .503-.198.68.68 0 0 0 .216-.478V4.751c0-.06-.039-.118-.082-.16zM8.687 1.48l3.226 3.157H8.679l.008-3.156zm3.466 13.391c0 .058-.038.116-.08.157a.262.262 0 0 1-.174.065H1.772a.32.32 0 0 1-.208-.075c-.05-.05-.1-.114-.1-.182V1.68c0-.124.126-.225.253-.225h6.496l-.007 3.407a.23.23 0 0 0 .07.162.242.242 0 0 0 .168.067h3.709v9.78z'
    />
  </svg>
);

const downloadMail = (color, width, height) => (
  <svg
    viewBox='0 0 26 20'
    width={width || 22}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#000'}
      d='M20.583 7.806V2.222C20.583.997 19.611 0 18.417 0H2.167C.972 0 0 .997 0 2.222v11.111c0 1.226.972 2.222 2.167 2.222h12.148c.71 2.561 3.006 4.444 5.727 4.444C23.327 20 26 17.259 26 13.889c0-3.182-2.385-5.801-5.417-6.083zM2.167 1.111h16.25c.022 0 .041.012.063.013l-7.73 6.511c-.284.189-.681.153-.867.036L2.104 1.124c.022-.001.041-.013.063-.013zm11.944 13.333H2.167c-.598 0-1.083-.499-1.083-1.111V2.222c0-.157.034-.306.092-.442l8.068 6.786a1.88 1.88 0 0 0 1.048.322 1.93 1.93 0 0 0 1.099-.359l8.017-6.75a1.12 1.12 0 0 1 .092.442v5.584c-3.032.282-5.417 2.901-5.417 6.083l.027.556zm5.931 4.444c-2.688 0-4.875-2.243-4.875-5s2.187-5 4.875-5 4.875 2.243 4.875 5-2.187 5-4.875 5zm1.934-4.149l-1.376 1.31v-5.478c0-.316-.268-.571-.6-.571s-.6.256-.6.571v5.478l-1.376-1.31a.62.62 0 0 0-.848 0 .55.55 0 0 0 0 .808l2.4 2.286A.61.61 0 0 0 20 18c.153 0 .307-.056.424-.167l2.4-2.286a.55.55 0 0 0 0-.808.62.62 0 0 0-.849 0z'
    />
  </svg>
);

const downloadTemplate = (color, width, height) => (
  <svg
    viewBox='0 0 12 15'
    width={width || 25}
    height={height || 25}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      strokeWidth='.3'
      fill={color || '#930000'}
      stroke={color || '#930000'}
      d='M6.93 5.91a.224.224 0 0 0-.227-.222H4.914c-.125 0-.226.1-.226.222v2.278H3.253a.227.227 0 0 0-.21.137.218.218 0 0 0 .05.242l2.556 2.5a.228.228 0 0 0 .32 0l2.556-2.5a.218.218 0 0 0 .05-.242.227.227 0 0 0-.21-.137H6.93V5.91zm.887 2.722L5.81 10.597 3.8 8.632h1.114c.126 0 .227-.1.227-.222V6.132h1.336V8.41c0 .123.101.222.226.222h1.114zm3.719-5.042L7.928.067A.243.243 0 0 0 7.76 0H.719C.336 0 0 .305 0 .68v13.156c0 .19.098.368.235.503a.785.785 0 0 0 .537.208h10.127a.73.73 0 0 0 .503-.198.68.68 0 0 0 .216-.478V3.751c0-.06-.039-.118-.082-.16zM7.687.48l3.226 3.157H7.679L7.687.481zm3.466 13.391c0 .058-.038.116-.08.157a.262.262 0 0 1-.174.065H.772a.32.32 0 0 1-.208-.075c-.05-.05-.1-.114-.1-.182V.68C.465.556.59.455.718.455h6.496l-.007 3.407a.23.23 0 0 0 .07.162.242.242 0 0 0 .168.067h3.709v9.78z'
    />
  </svg>
);

const driver = (color, width, height, subColor) => (
  <svg
    viewBox='0 0 14 15'
    width={width || 14}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none'>
      <path
        fill={color || '#015295'}
        d='M.12 14.573h2.417c.284-2.639 1.662-3.972 4.134-3.998s3.948 1.307 4.429 3.998h2.319c-.597-2.76-1.133-4.459-1.608-5.099s-1.53-1.214-3.17-1.722L6.77 9.608 4.874 7.752c-1.465.379-2.563.953-3.296 1.722S.36 11.944.12 14.574z'
      />
      <path
        strokeWidth='.7'
        stroke={color || '#015295'}
        d='M3.562 14.433h6.68c-.51-2.024-1.685-3.048-3.527-3.074s-2.893 1-3.153 3.074zm3.321-.073L9.1 12.504m-2.317 1.841v-2.984m.021 2.986l-2.524-1.66'
      />
      <path
        fill={color || '#015295'}
        d='M6.684 7.534c2.622.02 4.708-7.025.195-7.04s-2.816 7.021-.195 7.04z'
      />
      <path
        fill={subColor || '#cacaca'}
        d='M10.47 8.065l-2.763 2.863 1.033.445 2.756-2.937z'
      />
    </g>
  </svg>
);

const driver2 = (color, width, height) => (
  <svg
    viewBox='0 0 14 14'
    width={width || 14}
    height={height || 14}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#fff'}
      d='M6.552.041c-.96.2-1.682.872-1.933 1.805a2.92 2.92 0 0 0 0 1.23 2.53 2.53 0 0 0 1.78 1.769c.298.077.867.085 1.157.014C8.63 4.594 9.39 3.683 9.453 2.584 9.518 1.436 8.736.372 7.615.079A2.97 2.97 0 0 0 6.552.041zm-2.655 5.34c-.293.101-.52.287-.643.525a196.39 196.39 0 0 0-1.217 3.008 1.19 1.19 0 0 0 0 .604 1.08 1.08 0 0 0 .131.235c.049.063.454.424.9.801.757.634.826.686.957.711.077.016.145.022.153.014a36.49 36.49 0 0 0 .47-1.43c0-.014-.101-.052-.224-.085a1.24 1.24 0 0 0-.459-.052l-.232.008-.016-.396-.005-.407a1.21 1.21 0 0 1 .191-.025c.183-.014.186-.014.295-.148.142-.178.503-.495.741-.656a3.73 3.73 0 0 1 3.183-.454c.626.2 1.277.626 1.652 1.083l.134.164.189.011.194.025c.005.005.003.189-.005.407l-.016.396-.232-.008a1.24 1.24 0 0 0-.459.052c-.123.033-.224.071-.224.085s.104.339.232.725l.23.705.115-.008a.96.96 0 0 0 .161-.027c.088-.036 1.682-1.403 1.758-1.509a1.07 1.07 0 0 0 .115-.221 1.16 1.16 0 0 0 0-.596 226.61 226.61 0 0 0-1.178-2.926c-.131-.295-.355-.498-.662-.602-.167-.057-.208-.057-3.128-.057L3.9 5.382zm2.529 2.956a2.86 2.86 0 0 0-1.083.47c-.238.164-.336.262-.282.282.022.008.164.049.32.096l.301.098c.008.008-.038.178-.104.377l-.235.722-.115.364.235-.003h.238l.093-.197c.243-.511.837-.823 1.4-.738a1.37 1.37 0 0 1 1.012.738l.093.197h.238l.235.003-.115-.364-.235-.722-.104-.377a3.28 3.28 0 0 1 .32-.104c.17-.049.309-.101.312-.115.003-.038-.293-.273-.5-.391-.459-.265-.82-.364-1.381-.377-.328-.008-.457 0-.643.041zm.369 2.324a.61.61 0 0 0-.342.495c0 .216.18.443.399.509a.39.39 0 0 0 .295 0c.219-.066.399-.293.399-.509 0-.101-.066-.257-.145-.347-.164-.189-.396-.243-.607-.148zm-1.941 1.234c-.096.293-.112.325-.161.314-.202-.046-.372-.057-.372-.027 0 .074.232.492.386.695a2.89 2.89 0 0 0 1.58 1.058l.279.066c.014 0 .025-.347.025-.774v-.771l-.189-.088c-.252-.118-.489-.355-.61-.61l-.09-.189h-.369l-.372-.003-.107.328zm3.357-.14a1.38 1.38 0 0 1-.612.612l-.189.088v.771l.025.774a4.9 4.9 0 0 0 .284-.066 2.91 2.91 0 0 0 1.851-1.498c.12-.243.134-.306.063-.284l-.172.03-.164.03c-.033.008-.068-.063-.15-.317l-.107-.328h-.372-.369l-.088.189z'
    />
  </svg>
);

const driverCards = (color, width, height) => (
  <svg
    viewBox='0 0 25 25'
    width={width || 25}
    height={height || 25}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none'>
      <ellipse
        cy='12.5'
        ry='12.5'
        cx='12.399'
        rx='12.399'
        fill={color || '#fff'}
      />
      <g
        stroke='#ce2828'
        strokeWidth='.5'
      >
        <rect rx='1' x='3.25' y='8.25' width='18.5' height='9.5' />
        <path d='M12.5 10.5h7.565m-7.565 2h7.565m-7.565 2h5m-5 2h5' />
      </g>
      <path
        fill='#ce2828'
        d='M4.507 16.972h1.249c.147-1.414.859-2.128 2.136-2.142s2.04.7 2.289 2.142h1.198c-.308-1.479-.585-2.389-.831-2.732s-.791-.65-1.638-.922l-.967.994-.98-.994c-.757.203-1.324.511-1.703.922s-.629 1.323-.753 2.732z'
      />
      <path
        stroke='#ce2828'
        strokeWidth='.5'
        d='M6.285 16.897h3.452c-.264-1.084-.871-1.633-1.823-1.647s-1.495.536-1.629 1.647zm1.716-.039l1.146-.994m-1.197.986v-1.599m.011 1.6l-1.304-.889'
      />
      <path
        fill='#ce2828'
        d='M7.899 13.201c1.355.011 2.433-3.763.101-3.771s-1.455 3.761-.101 3.771z'
      />
      <path
        fill={color || '#fff'}
        d='M9.855 13.485l-1.428 1.534.534.238 1.424-1.573z'
      />
    </g>
  </svg>
);

const driverOnMap = (color, width, height) => (
  <svg
    viewBox='0 0 50 50'
    width={width || 50}
    height={height || 50}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g fill='none'>
      <circle
        cx='25'
        cy='25'
        r='22.5'
        strokeWidth='5'
        strokeOpacity='.3'
        fill={color || '#015295'}
        stroke={color || '#015295'}
      />
      <path
        fill='#fff'
        d='M14.2 37.29h4.028c.474-4.4 2.77-6.621 6.89-6.665s6.58 2.178 7.382 6.664h3.865c-.995-4.6-1.889-7.432-2.68-8.499s-2.552-2.023-5.284-2.87l-3.118 3.093-3.16-3.094c-2.44.632-4.271 1.589-5.492 2.871s-2.032 4.115-2.431 8.5z'
      />
      <path
        stroke='#fff'
        strokeWidth='.7'
        d='M19.545 37.055H31.07c-.85-3.373-2.81-5.08-5.88-5.123s-4.95 1.666-5.646 5.123zm5.926-.12l3.698-3.097m-3.864 3.071v-4.973m.035 4.976l-4.206-2.767'
      />
      <path
        fill='#fff'
        d='M25.14 25.557c4.37.033 7.846-11.709.325-11.735s-4.693 11.703-.324 11.735z'
      />
      <path
        fill={color || '#015295'}
        d='M31.45 26.442l-4.605 4.77 1.72.742 4.595-4.894z'
      />
    </g>
  </svg>
);

const drop = (color, width, height) => (
  <svg
    viewBox='0 0 20 20'
    width={width || 20}
    height={height || 20}
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle
      r='9.5'
      cx='9.5'
      cy='9.5'
      fill={color || '#353535'}
      transform='matrix(1 0 0 -1 0 19)'
    />
    <path
      fill='#f3f3f3'
      d='M12.853 9.35l-2.733 3.429c-.112.147-.262.221-.449.221s-.337-.074-.449-.184l-3.07-3.429c-.225-.258-.187-.627.037-.811.262-.221.636-.184.824.037l2.022 2.249V5.59c0-.332.262-.59.599-.59s.599.258.599.59v5.161l1.722-2.101a.59.59 0 0 1 .449-.221.73.73 0 0 1 .374.111c.262.221.3.59.075.811z'
    />
    <circle r='3.5' cx='15.5' cy='15.5' fill='#fff' />
    <path
      fill='#353535'
      d='M18.46 12.28c-.826-.825-1.923-1.28-3.091-1.28a4.34 4.34 0 0 0-3.091 1.28c-1.704 1.704-1.704 4.476 0 6.179.826.825 1.923 1.28 3.091 1.28a4.34 4.34 0 0 0 3.091-1.28c1.704-1.704 1.704-4.476 0-6.179zm-.562 5.617c-.676.675-1.574 1.047-2.529 1.047s-1.854-.372-2.529-1.047a3.58 3.58 0 0 1 0-5.056c.676-.675 1.574-1.047 2.529-1.047s1.854.372 2.529 1.047a3.58 3.58 0 0 1 0 5.056zm.096-2.592h-1.921v-1.921c0-.212-.172-.384-.384-.384s-.384.172-.384.384v1.921h-1.921c-.212 0-.384.172-.384.384s.172.384.384.384h1.921v1.921c0 .212.172.384.384.384s.384-.172.384-.384v-1.921h1.921c.212 0 .384-.172.384-.384s-.172-.384-.384-.384z'
    />
  </svg>
);

const dropStopIcon = (color, width, height, bgColor) => (
  <svg
    viewBox='0 0 15 15'
    width={width || 15}
    height={height || 15}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g transform='rotate(180 7.5 7.5)'>
      <circle
        r='7.5'
        cx='7.5'
        cy='7.5'
        fill={bgColor || '#2073a1'}
      />
      <path
        fill={color || '#f3f3f3'}
        d='M10.006 7.478L7.81 4.681a.429.429 0 0 0-.36-.181.5.5 0 0 0-.362.15L4.621 7.448c-.18.21-.15.512.03.662.211.18.512.15.662-.03l1.625-1.835v4.302c0 .27.21.481.481.481s.482-.21.482-.48V6.334L9.284 8.05a.47.47 0 0 0 .361.18c.09 0 .211-.03.301-.09.21-.18.241-.481.06-.662z'
      />
    </g>
  </svg>
);

const duplicateIcon = (color, width, height) => (
  <svg
    width={width || 16}
    height={height || 15}
    viewBox='0 0 683 683'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill={color || '#930000'}
      d='M226.3 2.5c-3.3 1.7-6.1 4.1-7.9 6.8l-2.9 4.2-.3 63.2-.2 63.3-62.9.2-62.8.3-4.8 3c-3.2 2-5.6 4.5-7.2 7.4l-2.3 4.4v256.2 256.2l2.3 4.2c1.2 2.4 4.2 5.7 6.6 7.5l4.3 3.1 181 .3 185.2-.9c5.1-1.4 12.1-8.3 13.5-13.6.7-2.5 1.1-25.1 1.1-64.6V543h60.1c39.9 0 61.5-.4 64.3-1.1 5.6-1.4 10.9-5.8 13.5-11.2l2.1-4.3v-182l-1.1-185.9c-.9-3.5-11.5-14.5-77.2-80.2S454 2 450.5 1.1C447.8.4 412.3 0 338.9 0H231.4l-5.1 2.5zm196.9 103.8l.3 64.4 3 4.9c2 3.1 4.7 5.8 7.5 7.4l4.5 2.5 64.3.3 64.2.3v157.4V501h-49-49v-99.1l-1.2-103.3c-1-3.6-11.2-14.2-77.2-80.3-65.7-65.7-76.6-76.3-80.1-77.2-2.4-.6-14.4-1.1-29.2-1.1H256V91 42h83.5 83.4l.3 64.3zm78.3 1.7l36 36h-36.3H465v-36l.3-36c.1 0 16.4 16.2 36.2 36zM283 244.1c0 44 .3 63.4 1.2 66.7 1.5 6.2 7.8 12.5 14 14 3.3.9 22.7 1.2 66.7 1.2H427v157.5V641H271.5 116V411.5 182h83.5H283v62.1zm78.5 3.9l36 36h-36.3H325v-36l.3-36c.1 0 16.4 16.2 36.2 36z'
    />
  </svg>
);

export {
  dnd,
  drop,
  dollar,
  driver,
  driver2,
  download,
  documents,
  dashboards,
  dispatcher,
  doTemplate,
  driverCards,
  driverOnMap,
  downloadMail,
  dropStopIcon,
  duplicateIcon,
  downloadButton,
  dispatchTemplate,
  dispatchingGroup,
  downloadDocument,
  downloadTemplate,
  dispatchTemplate2,
};
